var _tspan, _tspan2, _tspan3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnodesystemsLight = function SvgAnodesystemsLight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1975 759",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M286.72,520.074l-60.526,60.501l155.215,155.151l0.177,-0.177l0.077,0.077l155.215,-155.152l-60.526,-60.501l-57.643,57.619l0,-169.694l169.763,0l-57.542,57.519l60.526,60.501l155.215,-155.152l-60.526,-60.501l-0.017,0.018l-94.761,-94.723l-60.526,60.501l57.454,57.431l-169.586,0l0,-169.517l57.452,57.429l60.526,-60.501l-94.676,-94.637l0.022,-0.022l-60.526,-60.501l-0.022,0.022l-0.013,-0.013l-60.525,60.501l0.013,0.013l-94.668,94.629l60.526,60.501l57.454,-57.431l0,169.527l-169.61,0l55.89,-55.867l-60.526,-60.501l-153.637,153.574l0.035,0.034l-0.035,0.034l153.637,153.574l60.526,-60.501l-55.964,-55.941l169.684,0l0,169.705l-57.552,-57.529Zm94.765,215.729l1.224,1.223l-1.123,1.122l-1.223,-1.223l1.122,-1.122Zm0.009,-730.073l-1.287,-1.287l1.278,-1.278l1.287,1.287l-1.278,1.278Zm-365.139,365.002l-1.266,1.266l-1.266,-1.266l1.266,-1.265l1.266,1.265Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "3.68px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: "780.098px",
    y: "204.072px",
    style: {
      fontFamily: "'TimesNewRomanPSMT', 'Times New Roman', serif",
      fontSize: "238.946px",
      fill: "#fff"
    }
  }, "AN", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "1125.36px 1297.99px 1470.62px ",
    y: "204.072px 204.072px 204.072px "
  }, "ODE"))), /*#__PURE__*/React.createElement("text", {
    x: "780.098px",
    y: "469.302px",
    style: {
      fontFamily: "'TimesNewRomanPSMT', 'Times New Roman', serif",
      fontSize: "238.946px",
      fill: "#fff"
    }
  }, "SY", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "1085.67px 1218.62px 1364.63px 1510.65px 1723.2px ",
    y: "469.302px 469.302px 469.302px 469.302px 469.302px "
  }, "STEMS"))), /*#__PURE__*/React.createElement("text", {
    x: "780.098px",
    y: "734.532px",
    style: {
      fontFamily: "'TimesNewRomanPSMT', 'Times New Roman', serif",
      fontSize: "238.946px",
      fill: "#fff"
    }
  }, "CO", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "1112.17px 1324.72px 1435.72px 1608.35px ",
    y: "734.532px 734.532px 734.532px 734.532px "
  }, "MPAN")), "Y"))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnodesystemsLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/anodesystems-light.fbcaf1f0.svg";
export { ForwardRef as ReactComponent };